// extracted by mini-css-extract-plugin
export default {"title":"delete_title__S3kMX","buttonPart":"delete_buttonPart__KolV7","buttonCancel":"delete_buttonCancel__NIIaX","buttonDelete":"delete_buttonDelete__GJoU1"};